import React, { useRef } from 'react';
import { QRCode } from 'react-qrcode-logo';
import { useDispatch } from 'react-redux';

import { brandImage } from '../../../config/branding';
import { setNotificationDetails } from '../../../redux/slice/NotificationSlice';
import MyButton from '../../../shared-components/button/Button';

/**
 * Device qr code view and download
 * @returns
 */
function DeviceQrCode(properties: { deviceSN: string; handleClose: () => void }) {
  const { deviceSN, handleClose } = properties;

  const dispatch = useDispatch();
  const qrCodeCanvasReference = useRef<HTMLDivElement | null>(null);

  /**
   * Function to handle qr code download
   */
  const handleDownloadQRCode = () => {
    try {
      const canvas = qrCodeCanvasReference.current?.querySelector('canvas');
      if (canvas) {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png'); // Get the PNG data URL
        link.download = `${deviceSN}.png`; // File name for download
        link.click(); // Trigger the download
      }
      handleClose();
    } catch (error) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 200,
            message: 'Something went wrong!',
          },
        }),
      );
    }
  };

  return (
    <div className="device-qr-code-wrap">
      <div ref={qrCodeCanvasReference} className="device-qr-code-container">
        <div ref={qrCodeCanvasReference} className="device-qr-code">
          <QRCode
            value={`${process.env.REACT_APP_QR_CODE_URL}?deviceId=${deviceSN}`}
            logoImage={brandImage.qrLogo}
            removeQrCodeBehindLogo
          />
        </div>
      </div>
      <div className="device-qr-code-btn">
        <MyButton label="Cancel" buttonType="back" onClickFunc={handleClose} />
        <MyButton label="Download" buttonType="submit" onClickFunc={handleDownloadQRCode} />
      </div>
    </div>
  );
}

export default DeviceQrCode;
